import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_progress_circular = _resolveComponent("v-progress-circular");
    return (_ctx.isFetching)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            class: "progress-circular",
            size: 60,
            indeterminate: "",
            color: "primary darken-2"
        }))
        : _createCommentVNode("v-if", true);
}
